import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackBubbleButtonClick } from './tracking';
import { sendWsAnswer } from '../../actions/wsAnswer';
import { Promo, Socket } from '../../components/ActionButton';
import { currentOpenChatIDSelector } from '../../selectors';
import { EBubbleActionButtonType, TBubbleActionButton } from '../../types/messageBubble';
import { DemandActionContainer } from '../DemandActionContainer';

type TBubbleButtonContainerProps = {
  messageId: string;
  button: TBubbleActionButton;
  analyticsBubbleType: string;
};

const DEMAND_TRAP_LINK = 'homeownerLeadCreateMessage';

export const BubbleButtonContainer: React.VFC<TBubbleButtonContainerProps> = ({
  button,
  messageId,
  analyticsBubbleType,
}) => {
  const { link, type, text, socketPayload, analyticsButtonName } = button;

  const dispatch = useDispatch();

  const chatId = useSelector(currentOpenChatIDSelector) as string;

  const handleDeeplinkClick = React.useCallback(() => {
    trackBubbleButtonClick(chatId, analyticsBubbleType, analyticsButtonName);
  }, [analyticsBubbleType, analyticsButtonName, chatId]);

  const handleSocketClick = React.useCallback(() => {
    dispatch(sendWsAnswer({ messageId, payload: socketPayload as string }));
    trackBubbleButtonClick(chatId, analyticsBubbleType, analyticsButtonName);
  }, [analyticsBubbleType, analyticsButtonName, chatId, dispatch, messageId, socketPayload]);

  if (link === DEMAND_TRAP_LINK) {
    return <DemandActionContainer actionButton={button} />;
  }

  if (type === EBubbleActionButtonType.Socket) {
    return <Socket text={text} onClick={handleSocketClick} />;
  }

  if (type === EBubbleActionButtonType.Deeplink && link) {
    return <Promo link={link as string} text={text} onClick={handleDeeplinkClick} />;
  }

  return null;
};
